// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1DGgo","productName":"Table_productName__1SClP"};